import { axiosInstance } from 'api/apiConfig'
import { setNextPageParam } from 'api/apiUtil'
import { useInfiniteQuery, useMutation, useQuery } from 'react-query'
import { objectToQueryString } from 'utils/object-to-query-string'

// 사전상품 연결 신청
const getPreorderapplylst = async (target, params) => {
  const { data } = await axiosInstance.get(`/api/cmmty/preorder/v1.0/${target}${objectToQueryString(params)}`)
  return data
}

// 사전상품 연결 신청 리스트
const getPreorderAplctPsntList = async (target, params) => {
  // /api/head/preprdreq/v1.0/selectPreAplctPsntLst
  const { data } = await axiosInstance.get(`/api/head/preprdreq/v1.0/${target}${objectToQueryString(params)}`)
  return data
}

// 사전상품
const postHeadNotice = async (target, params) => {
  const { data } = await axiosInstance.post(`/api/head/preprdreq/v1.0${target ? '/' + target : ''}`, params)
  return data
}

// 사전상품 연결 요청
export const usePreorderapplylst = (params, isInit) => {
  return useInfiniteQuery(
    ['preorderapplylst'],
    ({ pageParam = params }) => getPreorderapplylst('preorderapplylst', pageParam),
    {
      enabled: isInit,
      getNextPageParam: setNextPageParam(params),
    },
  )
}

// 사전상품 연결 요청 상세
export const useGoodsAplcDtl = (params, isInit) => {
  return useQuery(['selectGoodsAplctDtl'], () => postHeadNotice('selectGoodsAplctDtl', params), {
    enabled: isInit,
  })
}

// 사전상품 연결 요청 삭제
export const useGoodsAplcDtDelete = ({ successHandler, errorHandler }) => {
  return useMutation((params) => postHeadNotice(`deleteGoodsAplctDtl`, params), {
    onSuccess: ({ data }) => {
      successHandler(data)
    },
    onError: (error) => {
      errorHandler(error)
    },
  })
}

// 사전상품 연결 요청 작성
export const useGoodsAplcDtRegist = ({ successHandler, errorHandler }) => {
  return useMutation((params) => postHeadNotice('insertGoodsAplctDtl', params), {
    onSuccess: ({ data }) => {
      successHandler(data)
    },
    onError: (error) => {
      errorHandler(error)
    },
  })
}

// 사전상품 연결 요청 리스트
export const usePreAplctPsntLst = (params, isInit) => {
  return useQuery(['selectPreAplctPsntLst', params], () => getPreorderAplctPsntList('selectPreAplctPsntLst', params), {
    enabled: isInit,
  })
}

// 매뉴검색
export const useMenuSearch = (params, isInit) => {
  return useQuery(
    ['goodsSrch', params],
    // ({ pageParam = params }) => getPreorderapplylst('goodsSrch', pageParam),
    () => getPreorderapplylst('goodsSrch', params),
    {
      enabled: isInit,
      // getNextPageParam: setNextPageParam(params),
    },
  )
}
